import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import classes from "./insurance.module.scss"

const Insurances = () => {
  const data = useStaticQuery(graphql`
    query Images {
      images: allFile(filter: { relativeDirectory: { eq: "insurances" } }) {
        nodes {
          childImageSharp {
            fluid(
              duotone: { highlight: "#ffffff", shadow: "#000000" }
              quality: 80
            ) {
              ...GatsbyImageSharpFluid
            }
          }
          id
        }
      }
    }
  `)

  return (
    <section className={classes.Insurances}>
      <p>Trabajamos con las siguientes obras sociales y arts</p>
      <div className={classes.Images}>
        {data.images.nodes.map(image => (
          <Img
            key={image.id}
            fluid={image.childImageSharp.fluid}
            className={classes.Image}
            alt="Obra social"
          />
        ))}
      </div>
    </section>
  )
}

export default Insurances
